// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 通用訂單樣式 */
.order-list-container,
.order-detail-container,
.order-new-container {
  padding-top: 10px;
  padding-bottom: 2rem;
  min-height: 70vh;
}

/* 客戶信息樣式 */
.customer-info {
  background-color: #f8f9fa;
  padding: 10px 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}

/* 產品列表樣式 */
.product-list {
  margin-top: 20px;
}

.product-table th,
.product-table td {
  vertical-align: middle;
}

/* .product-image {
  margin: 5px;
  height: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
} */

.detail-image img {
  min-height: 70px;
  min-width: 70px;
  max-height: 50%;
  max-width: 50%;
  overflow: hidden;
  align-items: center;
}

.detail-image span {
  vertical-align: middle;
}

.product-image img,
.product-image2 img {
  max-width: 100%;
  max-height: 99%;
  cursor: pointer;
}

.edit-image img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}

/* 訂單表格樣式 */
.order-table th,
.order-table td {
  vertical-align: middle;
}

/* 產品縮略圖 */
.product-thumbnail {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* 移動響應式調整 */
@media (max-width: 768px) {

  .order-list-container,
  .order-detail-container,
  .new-order-container {
    padding-top: 10px;
  }

  .product-table {
    font-size: 0.9rem;
  }

  .product-image {
    /* width: 40px; */
    height: 40px;
  }

  .product-card {
    max-width: 100%;
  }

  .product-image img,
  .product-image2 img {
    max-width: 70%;
    max-height: 70%;
  }
}

/* 表格固定標題 */
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1;
}

/* 產品列表樣式 */
.product-list {
  max-height: 400px;
  overflow-y: auto;
}

/* 訂單狀態標籤樣式 */
.status-badge {
  font-size: 0.85rem;
  padding: 0.45rem 0.3rem;
  /* padding: 0.25rem 0.5rem; */
}

/* 產品項目行樣式 */
.product-item-row:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

/* 產品網格樣式 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  /*調整卡片寬度 */
  gap: 10px;
  padding: 5px;
  /* max-height: 320px; */
  /* 調整容器高度 */
  overflow-y: scroll;
}

/* 產品卡片樣式 */
.product-card {
  min-width: 226px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  background-color: #f8f9fa;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.product-image {
  min-height: 84px;
  max-height: 84px;
  /* 增加高度，從原來的150px */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  overflow: hidden;
  margin-right: 5px;
  /* padding: 10px; */
}

.product-image2 {
  min-height: 104px;
  max-height: 114px;
  /* 增加高度，從原來的150px */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  overflow: hidden;
  margin-right: 5px;
  /* padding: 10px; */
}

.product-info {
  padding: 5px;
  text-align: center;
  align-items: center;
}

.product-title {
  font-size: 100%;
  /* margin-top: 3px; */
  /* margin-bottom: 5px; */
  font-weight: bold;
  /* height: 40px; */
  padding-top: 8px;
  padding-left: 20px;
  overflow: hidden;
  display: -webkit-box;
  line-clamp: 2;
  box-orient: vertical;
  line-height: 1.3;
}

.type-title {
  font-size: 100%;
  /* margin-right: 15px; */
  padding-right: 7px;
  text-align: right;
  min-width: 40px;
  overflow: hidden;
  /* display: -webkit-box; */
  /* -webkit-line-clamp: 1; */
  /* -webkit-box-orient: vertical; */
}

/* 產品縮略圖樣式 */
.product-thumbnail {
  width: 70px;
  /* 從原來的50px增加 */
  height: 70px;
  /* 從原來的50px增加 */
  object-fit: contain;
  border-radius: 4px;
  padding: 5px;
}

/* 產品縮略圖樣式 */
.confirm-thumbnail {
  width: 70%;
  height: 70%;
  max-height: 60px;
  object-fit: contain;
  border-radius: 2px;
  /* padding: 2px; */
}

/* 產品搜尋框樣式 */
.product-search {
  max-width: 300px;
}

.order-products-table th:first-child,
.order-products-table td:first-child {
  width: 90px;
  /* 調整寬度以適應更大的縮略圖 */
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
}

.modalS,
.modalL {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 100px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.modalS-content {
  background-color: #fefefe;
  margin: auto;
  padding: 10px;
  border: 1px solid #888;
  max-width: 70%;
}

.modalL-content {
  background-color: #fefefe;
  margin: auto;
  padding: 10px;
  border: 1px solid #888;
  max-width: 90%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.star {
  visibility: hidden;
  margin-left: 5px;
  float: left;
  font-size: 25px;
  cursor: pointer;
}

.star:before {
  content: "\\2606";
  color: #f7c707;
  /* position: absolute; */
  visibility: visible;
}

.star:checked:before {
  content: "\\2605";
  /* position: absolute; */
}

.newproduct {
  /* margin-right: 9px; */
  font-weight: bold;
  /* float: right; */
  font-size: 13px;
  color: #c90606;
  visibility: visible;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-row select {
  width: 72%;
  float: inline-end;
}

.form-row label {
  width: 28%;
  display: inline-block;
}


.confirm {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 170px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

/* Modal Content */
.confirm-content {
  background-color: #fefefe;
  margin: auto;
  padding-top: 0px;
  border: 1px solid #4a9cf3;
  width: 194px;
}

.confirm-content h6 {
  background-color: #4a9cf3;
  /* Specific color for the heading */
}

.error {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 170px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.error-content {
  background-color: #fefefe;
  margin: auto;
  padding-top: 0px;
  border: 1px solid #ea3e1b;
  width: 294px;
}

.error-content h6 {
  background-color: #ea3e1b;
  /* Specific color for the heading */
}

.enlarged {
  transform: scale(1.5);
  /* Enlarges the image by 50% */
}

.form-check-input {
  transform: scale(1.3);           /* 1.5× → 2× → adjust as needed */
  margin-right: 0.45rem;              /* fix vertical alignment if needed */
}

.form-check-input:invalid {
  border: 2px solid #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/pages/Order/Order.css"],"names":[],"mappings":"AAAA,WAAW;AACX;;;EAGE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;;;;GAOG;;AAEH;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,WAAW;AACX;;EAEE,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;;EAEE;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,4DAA4D;EAC5D,UAAU;EACV,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB,YAAY,iCAAiC;EAClE,qBAAqB,eAAe,qCAAqC;AAC3E;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C","sourcesContent":["/* 通用訂單樣式 */\n.order-list-container,\n.order-detail-container,\n.order-new-container {\n  padding-top: 10px;\n  padding-bottom: 2rem;\n  min-height: 70vh;\n}\n\n/* 客戶信息樣式 */\n.customer-info {\n  background-color: #f8f9fa;\n  padding: 10px 15px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n/* 產品列表樣式 */\n.product-list {\n  margin-top: 20px;\n}\n\n.product-table th,\n.product-table td {\n  vertical-align: middle;\n}\n\n/* .product-image {\n  margin: 5px;\n  height: 100px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n} */\n\n.detail-image img {\n  min-height: 70px;\n  min-width: 70px;\n  max-height: 50%;\n  max-width: 50%;\n  overflow: hidden;\n  align-items: center;\n}\n\n.detail-image span {\n  vertical-align: middle;\n}\n\n.product-image img,\n.product-image2 img {\n  max-width: 100%;\n  max-height: 99%;\n  cursor: pointer;\n}\n\n.edit-image img {\n  max-width: 100%;\n  max-height: 100%;\n  vertical-align: middle;\n}\n\n/* 訂單表格樣式 */\n.order-table th,\n.order-table td {\n  vertical-align: middle;\n}\n\n/* 產品縮略圖 */\n.product-thumbnail {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n/* 移動響應式調整 */\n@media (max-width: 768px) {\n\n  .order-list-container,\n  .order-detail-container,\n  .new-order-container {\n    padding-top: 10px;\n  }\n\n  .product-table {\n    font-size: 0.9rem;\n  }\n\n  .product-image {\n    /* width: 40px; */\n    height: 40px;\n  }\n\n  .product-card {\n    max-width: 100%;\n  }\n\n  .product-image img,\n  .product-image2 img {\n    max-width: 70%;\n    max-height: 70%;\n  }\n}\n\n/* 表格固定標題 */\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* 產品列表樣式 */\n.product-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* 訂單狀態標籤樣式 */\n.status-badge {\n  font-size: 0.85rem;\n  padding: 0.45rem 0.3rem;\n  /* padding: 0.25rem 0.5rem; */\n}\n\n/* 產品項目行樣式 */\n.product-item-row:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n/* 產品網格樣式 */\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  /*調整卡片寬度 */\n  gap: 10px;\n  padding: 5px;\n  /* max-height: 320px; */\n  /* 調整容器高度 */\n  overflow-y: scroll;\n}\n\n/* 產品卡片樣式 */\n.product-card {\n  min-width: 226px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n  background-color: #f8f9fa;\n}\n\n.product-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.product-image {\n  min-height: 84px;\n  max-height: 84px;\n  /* 增加高度，從原來的150px */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  overflow: hidden;\n  margin-right: 5px;\n  /* padding: 10px; */\n}\n\n.product-image2 {\n  min-height: 104px;\n  max-height: 114px;\n  /* 增加高度，從原來的150px */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  overflow: hidden;\n  margin-right: 5px;\n  /* padding: 10px; */\n}\n\n.product-info {\n  padding: 5px;\n  text-align: center;\n  align-items: center;\n}\n\n.product-title {\n  font-size: 100%;\n  /* margin-top: 3px; */\n  /* margin-bottom: 5px; */\n  font-weight: bold;\n  /* height: 40px; */\n  padding-top: 8px;\n  padding-left: 20px;\n  overflow: hidden;\n  display: -webkit-box;\n  line-clamp: 2;\n  box-orient: vertical;\n  line-height: 1.3;\n}\n\n.type-title {\n  font-size: 100%;\n  /* margin-right: 15px; */\n  padding-right: 7px;\n  text-align: right;\n  min-width: 40px;\n  overflow: hidden;\n  /* display: -webkit-box; */\n  /* -webkit-line-clamp: 1; */\n  /* -webkit-box-orient: vertical; */\n}\n\n/* 產品縮略圖樣式 */\n.product-thumbnail {\n  width: 70px;\n  /* 從原來的50px增加 */\n  height: 70px;\n  /* 從原來的50px增加 */\n  object-fit: contain;\n  border-radius: 4px;\n  padding: 5px;\n}\n\n/* 產品縮略圖樣式 */\n.confirm-thumbnail {\n  width: 70%;\n  height: 70%;\n  max-height: 60px;\n  object-fit: contain;\n  border-radius: 2px;\n  /* padding: 2px; */\n}\n\n/* 產品搜尋框樣式 */\n.product-search {\n  max-width: 300px;\n}\n\n.order-products-table th:first-child,\n.order-products-table td:first-child {\n  width: 90px;\n  /* 調整寬度以適應更大的縮略圖 */\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  appearance: textfield;\n}\n\n.modalS,\n.modalL {\n  display: none;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  padding-top: 100px;\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n}\n\n/* Modal Content */\n.modalS-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 10px;\n  border: 1px solid #888;\n  max-width: 70%;\n}\n\n.modalL-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 10px;\n  border: 1px solid #888;\n  max-width: 90%;\n}\n\n/* The Close Button */\n.close {\n  color: #aaaaaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.star {\n  visibility: hidden;\n  margin-left: 5px;\n  float: left;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.star:before {\n  content: \"\\2606\";\n  color: #f7c707;\n  /* position: absolute; */\n  visibility: visible;\n}\n\n.star:checked:before {\n  content: \"\\2605\";\n  /* position: absolute; */\n}\n\n.newproduct {\n  /* margin-right: 9px; */\n  font-weight: bold;\n  /* float: right; */\n  font-size: 13px;\n  color: #c90606;\n  visibility: visible;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.form-row select {\n  width: 72%;\n  float: inline-end;\n}\n\n.form-row label {\n  width: 28%;\n  display: inline-block;\n}\n\n\n.confirm {\n  display: none;\n  position: fixed;\n  z-index: 1;\n  padding-top: 170px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n/* Modal Content */\n.confirm-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding-top: 0px;\n  border: 1px solid #4a9cf3;\n  width: 194px;\n}\n\n.confirm-content h6 {\n  background-color: #4a9cf3;\n  /* Specific color for the heading */\n}\n\n.error {\n  display: none;\n  position: fixed;\n  z-index: 1;\n  padding-top: 170px;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgb(0, 0, 0);\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.error-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding-top: 0px;\n  border: 1px solid #ea3e1b;\n  width: 294px;\n}\n\n.error-content h6 {\n  background-color: #ea3e1b;\n  /* Specific color for the heading */\n}\n\n.enlarged {\n  transform: scale(1.5);\n  /* Enlarges the image by 50% */\n}\n\n.form-check-input {\n  transform: scale(1.3);           /* 1.5× → 2× → adjust as needed */\n  margin-right: 0.45rem;              /* fix vertical alignment if needed */\n}\n\n.form-check-input:invalid {\n  border: 2px solid #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
